<script>
	// Stores 
	import { textSite } from '../store.js';    
	
	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";

	import PageHeader	from "../components/PageHeader.svelte";
	import Vitrine		from '../components/Vitrine.svelte'

   	// Code	
	let titlePage = 'Parcelinha';

	let vitrines = [
		{
			image: 'vitrineParcelinha.png', 
			imageMobile: 'vitrineParcelinhaM.png', 
			title: 'Parcelinha',
			href: '#'
		},
	];


	let itens = [
		{
			icon: 'fas fa-calculator',
			title: 'Simulação Grátis',
			text: 'Acesse o site <a class="laranja" href="https://parcelinhadigital.com.br/" target="_blank">parcelinhadigital.com.br</a> e insira o valor da sua conta para começar a simulação.'
		},
		{
			icon: 'fas fa-coins',
			title: 'Número de Parcelas',
			text: 'Escolha uma das opções apresentadas (3x, 6x, 9x ou 12x).'
		},
		{
			icon: 'fas fa-tag',
			title: 'Cupom de desconto',
			text: 'Insira o cupom de desconto <span class="color-secondary">DESCONTOFREIRE</span> para obter uma melhor negociação.'
		},
		{
			icon: 'fas fa-edit',
			title: 'Insira seus dados',
			text: 'Gostou da proposta? Insira os dados solicitados.'
		},
		{
			icon: 'fas fa-comments',
			title: 'Contato de verificação',
			text: 'A equipe da Parcelinha Digital entrará em contato para confirmar a operação.'
		},
		{
			icon: 'fas fa-credit-card',
			title: 'Link para pagamento',
			text: 'Um link será enviado para você confirmar seu pagamento no cartão de crédito. <span class="color-secondary">Você pode usar até 4 cartões!</span>'
		},
		{
			icon: 'fas fa-bullseye-arrow',
			title: 'Aprovação e comprovante',
			text: 'Aprovando o pagamento, o seu boleto é pago na hora e você recebe o comprovante de quitação.'
		},
	];
</script>

<Vitrine vitrines={vitrines} showDots={false} vitrineHeight="460px"/>

<PageHeader title={titlePage} buttons="">
	<div class="subtitle" slot="subtitle">
		<div class="container">
			<p class="mt-20">Como pagar seus boletos com a Parcelinha Digital</p>
			<p>Veja como é fácil parcelar seu Aluguel ou Condomínio:</p>
		</div>
	</div>
</PageHeader>

<div class="container clearfix">
	<div class="itens flex flex-wrap flex-column gap-20 mb-20">
		{#each itens as item, i}
		<div class="item flex-1 background-gray round-all pa-20 text-center flex flex-column gap-15">
			<div class="icon flex flex-center gap-10">
				{i+1} <i class="{item.icon} color-secondary"></i> 
			</div>
			<p class="p-0 m-0 text-bold">{item.title}</p>
			<p class="p-0 m-0">{@html item.text}</p>
			
		</div>
		{/each}
	</div>
</div>

<div class="background-gray">
	<div class="container clearfix text-center">
		<div class="text-subtitle text-bold pt-30">Parcelou, respirou!</div>	
		<p class="pt-10 pb-20 m-0">Acesse pelo link abaixo e informe o cupom de desconto: <span class="color-secondary">DESCONTOFREIRE</span></p>
		<div class="flex flex-center gap-20 pb-30">
			<a href="https://www.parcelinhadigital.com.br" class="btn btn-primary text-bold ">www.parcelinhadigital.com.br</a>
		</div>
	</div>
</div>

<style type="text/sass">
	.itens .icon
		font-size: 36px
</style>